import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=a9bb4748&scoped=true"
import script from "./QuotationList.vue?vue&type=script&lang=js"
export * from "./QuotationList.vue?vue&type=script&lang=js"
import style0 from "./QuotationList.vue?vue&type=style&index=0&id=a9bb4748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bb4748",
  null
  
)

export default component.exports